// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.cp-popinfo {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n}\n.cp-popinfo > div > span {\n  display: inline-block;\n}\n.cp-popinfo > div > span:first-child {\n  color: #075bb9;\n  font-weight: 500;\n  margin-right: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
